import { INTERNAL_SERVER_ERROR, NO_CONTENT } from "../constants/response-status-codes";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { APIConnector } from "./api/APIConnector";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { createPagination } from "./utilities/paginationBuilder";
import { getFilterClause, createPartialURL } from "./utilities/urlBuilder";
import { Deserializer } from 'jsonapi-serializer';
import { DEVICE_CATEGORIES } from "../constants/device-constants";

const apiConnector = new APIConnector();

export const clearTerminal = async (terminalId): Promise<boolean> => {
    const url = `terminal/${terminalId}`;

    const newTerminal = {
        data: {
            type: "terminal",
            id: terminalId,
            attributes: {
                unlinkLocation: true
            },
            relationships: {
                location: {
                    data: undefined
                }
            }
        }
    }
    let response: Response;
    await apiConnector.sendData(url, false, newTerminal)
        .then((data) => {
            response = data;
        })
        .catch((error) => {
            console.log(`Clearing terminal error: ${error}`);
        });
    return new Promise((resolve, reject) => {
        response
            ? response.status === NO_CONTENT ? resolve(true)
                : reject(false)
            : reject({status: INTERNAL_SERVER_ERROR, message: genericError });
    });
}

export const getAvailableTerminals = async (listQuery?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        let filter: string = getFilterClause(listQuery?.filters, listQuery?.searchTerm);
        filter = filter ? `${filter};location=isnull=true;unitType.utCategory=in=(${DEVICE_CATEGORIES.READER},${DEVICE_CATEGORIES.BIOMETRIC_READER},${DEVICE_CATEGORIES.EL_LOCK_ENTRY},${DEVICE_CATEGORIES.EL_LOCK_EXIT},${DEVICE_CATEGORIES.LOCK})` 
                        : `&filter=location=isnull=true`;
        const paginationString = createPartialURL(listQuery?.goToPage, listQuery?.pageSize, listQuery?.sortBy, filter);
        const url = `terminal?fields[terminal]=devName&fields[unitType]=utCategory${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, items: any[]) => {
                if (err) {
                    return reject({ status: response.status, message: genericError });
                }

                const terminals: Name[] = items.map((terminal): Name => {
                    return {
                        value: terminal['id'],
                        label: terminal['dev-name']
                    };
                });

                return resolve({ rows: terminals, pagination: newPagination });
            })

        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
